// REQ-P1-06b: アーティスト向けオファー/契約導線の契約型付きAPI。

import { api, requestApiJson, type paths } from './client';
import type { operations } from './types.gen';

type ArtistOfferDetailResponse = NonNullable<
  paths['/artist/offer-details/{holdCastingId}']['get']['responses'][200]['content']
>['application/json'];
type ArtistOfferResponseRequest = NonNullable<
  paths['/artist/respond-offer']['post']['requestBody']
>['content']['application/json'];
type ArtistContractResponseRequest = NonNullable<
  paths['/artist/respond-contract']['post']['requestBody']
>['content']['application/json'];
type ArtistContractDetailResponse = NonNullable<
  paths['/artist/contract-detail/{contractArtistId}']['get']['responses'][200]['content']
>['application/json'];
type AdminContractDetailResponse = NonNullable<
  paths['/admin/contract-detail/{contractArtistId}']['get']['responses'][200]['content']
>['application/json'];
type AdminContractInvoiceRegistrationReviewRequest = NonNullable<
  paths['/admin/contracts/{contractArtistId}/invoice-registration-review']['post']['requestBody']
>['content']['application/json'];
type AdminContractDocumentRevisionHistoryResponse = NonNullable<
  paths['/admin/contract-artists/{contractArtistId}/document-revisions']['get']['responses'][200]['content']
>['application/json'];
type AdminHoldCastingDetailResponse = NonNullable<
  paths['/admin/hold-casting-detail/{holdCastingArtistId}']['get']['responses'][200]['content']
>['application/json'];
type AdminHoldCastingDetailByHoldQuery = NonNullable<
  paths['/admin/hold-casting-detail/by-hold/{holdCastingId}']['get']['parameters']['query']
>;
type AdminHoldCastingDetailByHoldResponse = NonNullable<
  paths['/admin/hold-casting-detail/by-hold/{holdCastingId}']['get']['responses'][200]['content']
>['application/json'];
type OfferChangeLogsResponse = NonNullable<
  paths['/common/offer-change-logs/{holdCastingId}']['get']['responses'][200]['content']
>['application/json'];
type ResendCancelledHoldCastingRequest = NonNullable<
  paths['/admin/hold-casting/{holdCastingId}/resend']['post']['requestBody']
>['content']['application/json'];
type HoldCastingDraftListQuery = NonNullable<
  paths['/admin/hold-casting-drafts']['get']['parameters']['query']
>;
type HoldCastingDraftListResponse = NonNullable<
  paths['/admin/hold-casting-drafts']['get']['responses'][200]['content']
>['application/json'];
type SaveHoldCastingDraftRequest = NonNullable<
  paths['/admin/hold-casting-drafts']['post']['requestBody']
>['content']['application/json'];
type ContractDraftListQuery = NonNullable<
  paths['/admin/contract-drafts']['get']['parameters']['query']
>;
type ContractDraftListResponse = NonNullable<
  paths['/admin/contract-drafts']['get']['responses'][200]['content']
>['application/json'];
type SaveContractDraftRequest = NonNullable<
  paths['/admin/contract-drafts']['post']['requestBody']
>['content']['application/json'];
type SubmitContractRequest = NonNullable<
  paths['/admin/submit-contract']['post']['requestBody']
>['content']['application/json'];
type SubmitContractResponse = NonNullable<
  paths['/admin/submit-contract']['post']['responses'][200]['content']
>['application/json'];
type CreateHoldCastingRequest = NonNullable<
  operations['createHoldCasting']['requestBody']
>['content']['application/json'];
type ContractPrefillResponse = NonNullable<
  paths['/admin/contracts/{contractId}/prefill']['get']['responses'][200]['content']
>['application/json'];
type AdminContractClausePolicyResponse = NonNullable<
  paths['/admin/contract-clause-policy']['get']['responses'][200]['content']
>['application/json'];
type FinalizeRevenueShareRewardRequest = NonNullable<
  paths['/admin/contracts/{contractArtistId}/finalize-revenue-share-reward']['post']['requestBody']
>['content']['application/json'];
type RecentContractsQuery = NonNullable<
  paths['/admin/contracts/recent']['get']['parameters']['query']
>;
type ArtistContractInvoiceConfirmResponse = NonNullable<
  paths['/artist/contracts/{contractArtistId}/confirm-invoice']['post']['responses'][200]['content']
>['application/json'];
type ArtistSupplementalInvoiceConfirmResponse = NonNullable<
  paths['/artist/supplemental-invoices/{supplementalInvoiceId}/confirm-invoice']['post']['responses'][200]['content']
>['application/json'];
type BulkCancelCompensationRequest = NonNullable<
  paths['/admin/events/{eventUuid}/cancel-compensation/bulk']['post']['requestBody']
>['content']['application/json'];
type SupplementalInvoiceMutationRequest = NonNullable<
  paths['/admin/contracts/{contractArtistId}/supplemental-invoices']['post']['requestBody']
>['content']['application/json'];
type ContractUpdatePersonalRequest = NonNullable<
  paths['/admin/contract/update-personal']['post']['requestBody']
>['content']['application/json'];
type ContractResendUnchangedRequest = NonNullable<
  paths['/admin/contract-artists/{contractArtistId}/resend-unchanged']['post']['requestBody']
>['content']['application/json'];
type ContractUpdateCommonRequest = NonNullable<
  paths['/admin/contract/update-common']['post']['requestBody']
>['content']['application/json'];
type CommonContractAffectedArtistsResponse = NonNullable<
  paths['/admin/contract/common-affected-artists/{contractArtistId}']['get']['responses'][200]['content']
>['application/json'];
type CancelContractRequest = NonNullable<
  paths['/admin/cancel-contract']['post']['requestBody']
>['content']['application/json'];
type CancelHoldCastingRequest = NonNullable<
  paths['/admin/cancel-hold-casting']['post']['requestBody']
>['content']['application/json'];
type MarkHoldCastingContractSentRequest = NonNullable<
  paths['/admin/hold-casting/mark-contract-sent']['post']['requestBody']
>['content']['application/json'];
type HoldCastingDeclineRequest = NonNullable<
  paths['/admin/hold-casting/decline']['post']['requestBody']
>['content']['application/json'];
type ContractArtistsResponse = NonNullable<
  paths['/admin/contract-artists']['get']['responses'][200]['content']
>['application/json'];
type ApprovedArtistsForContractResponse = NonNullable<
  paths['/admin/approved-artists/{eventId}']['get']['responses'][200]['content']
>['application/json'];
type LatestHoldCastingByEventsRequest = NonNullable<
  paths['/admin/hold-casting/latest-by-events']['post']['requestBody']
>['content']['application/json'];
type LatestHoldCastingByEventsResponse = NonNullable<
  paths['/admin/hold-casting/latest-by-events']['post']['responses'][200]['content']
>['application/json'];
type EventContractArtistStatusQuery = NonNullable<
  paths['/admin/contracts/event/{eventUuid}/artist-status']['get']['parameters']['query']
>;
export type AdditionalRewardTarget = NonNullable<
  paths['/admin/contracts/events/{eventUuid}/additional-reward-targets']['get']['responses'][200]['content']
>['application/json']['items'][number];
export type EventContractScheduleTarget = NonNullable<
  paths['/admin/contracts/events/{eventUuid}/schedule-targets']['get']['responses'][200]['content']
>['application/json']['items'][number];
export type EventContractScheduleBatchRequest = NonNullable<
  paths['/admin/contracts/events/{eventUuid}/schedule-batch']['post']['requestBody']
>['content']['application/json'];
export type AdditionalRewardRequest = NonNullable<
  paths['/artist/contracts/{contractArtistId}/additional-reward-requests']['get']['responses'][200]['content']
>['application/json']['items'][number];
type AdminAdditionalRewardOfferBulkRequest = NonNullable<
  paths['/admin/contracts/events/{eventUuid}/additional-reward-offers']['post']['requestBody']
>['content']['application/json'];
type ArtistAdditionalRewardClaimRequest = NonNullable<
  paths['/artist/contracts/{contractArtistId}/additional-reward-claims']['post']['requestBody']
>['content']['application/json'];
type ArtistAdditionalRewardOfferResponseRequest = NonNullable<
  paths['/artist/additional-reward-requests/{requestId}/respond']['post']['requestBody']
>['content']['application/json'];
type AdminAdditionalRewardItemDecisionRequest = NonNullable<
  paths['/admin/contracts/additional-reward-items/{itemId}/decision']['post']['requestBody']
>['content']['application/json'];
type CastingRecommendationsRequest = NonNullable<
  operations['createCastingRecommendations']['requestBody']
>['content']['application/json'];
type CastingRecommendationsResponse = NonNullable<
  operations['createCastingRecommendations']['responses'][200]['content']
>['application/json'];
export type CastingArtistSelectionQuery = NonNullable<
  paths['/admin/casting-artist-selection']['get']['parameters']['query']
>;
export type CastingArtistSelectionResponse = NonNullable<
  paths['/admin/casting-artist-selection']['get']['responses'][200]['content']
>['application/json'];
export type CastingArtistPreviewResponse = NonNullable<
  paths['/admin/casting-artist-selection/{artistId}/preview']['get']['responses'][200]['content']
>['application/json'];
export type CastingPastEventsQuery = NonNullable<
  paths['/admin/casting-past-events']['get']['parameters']['query']
>;
export type CastingPastEventsResponse = NonNullable<
  paths['/admin/casting-past-events']['get']['responses'][200]['content']
>['application/json'];
type ApiResult<T> = {
  ok: boolean;
  status: number;
  data: T | undefined;
};
type ApiBlobResult = {
  ok: boolean;
  status: number;
  blob: Blob | undefined;
  message: string | undefined;
};
type OfferFormJsonRequestOptions = {
  method?: string;
  headers?: Record<string, string>;
  body?: XMLHttpRequestBodyInit | null;
};

function toApiResult<T>(result: {
  data?: T;
  error?: unknown;
  response: Response;
}): ApiResult<T> {
  return {
    ok: result.response.ok,
    status: result.response.status,
    data: (result.data ?? result.error) as T | undefined,
  };
}

function getApiErrorMessage(error: unknown): string | undefined {
  if (!error) return undefined;
  if (typeof error === 'string') return error;
  if (typeof error !== 'object') return undefined;
  const record = error as Record<string, unknown>;
  return typeof record.message === 'string' ? record.message : undefined;
}

function toBlobResult(
  result: { data?: Blob; error?: unknown; response: Response },
  fallbackMessage: string
): ApiBlobResult {
  return {
    ok: result.response.ok,
    status: result.response.status,
    blob: result.response.ok ? result.data : undefined,
    message: result.response.ok ? undefined : getApiErrorMessage(result.error) || fallbackMessage,
  };
}

export function requestOfferFormJson(
  url: string,
  options: OfferFormJsonRequestOptions = {}
): Promise<Record<string, unknown>> {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open(String(options.method || 'GET').toUpperCase(), url);
    request.withCredentials = true;
    request.setRequestHeader('Accept', 'application/json');
    Object.entries(options.headers || {}).forEach(([key, value]) => {
      if (value != null) request.setRequestHeader(key, String(value));
    });

    request.onload = () => {
      const contentType = request.getResponseHeader('content-type') || '';
      if (request.status < 200 || request.status >= 300) {
        const error = new Error(`Network response was not ok (${request.status})`) as Error & {
          status?: number;
          body?: string;
        };
        error.status = request.status;
        error.body = request.responseText || '';
        reject(error);
        return;
      }
      if (!contentType.includes('application/json')) {
        resolve({});
        return;
      }
      try {
        const parsed = request.responseText ? JSON.parse(request.responseText) : {};
        resolve(parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {});
      } catch (error) {
        reject(error);
      }
    };

    request.onerror = () => reject(new Error('Network request failed'));
    request.onabort = () => reject(new Error('Network request aborted'));
    request.ontimeout = () => reject(new Error('Network request timed out'));
    request.send(options.body || null);
  });
}

async function readJsonObject(response: Response): Promise<Record<string, unknown>> {
  try {
    const json = await response.clone().json();
    return json && typeof json === 'object' ? (json as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

function parseJsonText(raw: unknown): Record<string, unknown> {
  if (raw && typeof raw === 'object') return raw as Record<string, unknown>;
  if (typeof raw !== 'string' || !raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

async function toJsonMutationResult(
  result: { data?: unknown; error?: unknown; response: Response },
  fallbackMessage: string
): Promise<Record<string, unknown>> {
  const data =
    result.data && typeof result.data === 'object'
      ? (result.data as Record<string, unknown>)
      : await readJsonObject(result.response);
  const errorMessage = getApiErrorMessage(result.error);
  if (!result.response.ok || data.success === false) {
    throw new Error(
      (typeof data.message === 'string' && data.message) ||
        errorMessage ||
        fallbackMessage
    );
  }
  return data;
}

export async function getArtistOfferDetail(
  holdCastingId: string
): Promise<ApiResult<ArtistOfferDetailResponse>> {
  const result = await api.GET('/artist/offer-details/{holdCastingId}', {
    params: { path: { holdCastingId } },
  });
  return toApiResult(result);
}

export async function getArtistContractDetail(
  contractArtistId: string
): Promise<ApiResult<ArtistContractDetailResponse>> {
  const result = await api.GET('/artist/contract-detail/{contractArtistId}', {
    params: { path: { contractArtistId } },
  });
  return toApiResult(result);
}

export async function getAdminContractDetail(
  contractArtistId: string
): Promise<Record<string, unknown>> {
  const result = await api.GET('/admin/contract-detail/{contractArtistId}', {
    params: { path: { contractArtistId } },
  });
  if (!result.response.ok) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '契約詳細の取得に失敗しました。'
    );
  }
  return (result.data || {}) as AdminContractDetailResponse;
}

export async function getAdminContractDocumentRevisions(
  contractArtistId: string,
  query: { before_revision_number?: number; limit?: number } = {}
): Promise<AdminContractDocumentRevisionHistoryResponse> {
  const result = await api.GET(
    '/admin/contract-artists/{contractArtistId}/document-revisions',
    { params: { path: { contractArtistId }, query } }
  );
  if (!result.response.ok) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '契約版履歴の取得に失敗しました。'
    );
  }
  return result.data as AdminContractDocumentRevisionHistoryResponse;
}

export async function finalizeAdminRevenueShareReward(
  contractArtistId: string,
  body: FinalizeRevenueShareRewardRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST(
    '/admin/contracts/{contractArtistId}/finalize-revenue-share-reward',
    { params: { path: { contractArtistId } }, body }
  );
  return toJsonMutationResult(result, 'レベニューシェア報酬の確定に失敗しました。');
}

export async function getAdminHoldCastingDetail(
  holdCastingArtistId: string
): Promise<Record<string, unknown>> {
  const result = await api.GET('/admin/hold-casting-detail/{holdCastingArtistId}', {
    params: { path: { holdCastingArtistId } },
  });
  if (!result.response.ok) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        'オファー詳細の取得に失敗しました'
    );
  }
  return (result.data || {}) as AdminHoldCastingDetailResponse;
}

export async function getAdminHoldCastingDetailByHold(
  holdCastingId: string,
  query: AdminHoldCastingDetailByHoldQuery = {}
): Promise<Record<string, unknown>> {
  const result = await api.GET('/admin/hold-casting-detail/by-hold/{holdCastingId}', {
    params: { path: { holdCastingId }, query },
  });
  if (!result.response.ok) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        'オファー詳細の取得に失敗しました'
    );
  }
  return (result.data || {}) as AdminHoldCastingDetailByHoldResponse;
}

export async function getOfferChangeLogs(
  holdCastingId: string,
  artistId: string
): Promise<OfferChangeLogsResponse> {
  const result = await api.GET('/common/offer-change-logs/{holdCastingId}', {
    params: { path: { holdCastingId }, query: { artist_id: artistId } },
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        'オファー変更履歴の取得に失敗しました。'
    );
  }
  return result.data;
}

export async function resendCancelledHoldCasting(
  holdCastingId: string,
  body: ResendCancelledHoldCastingRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/hold-casting/{holdCastingId}/resend', {
    params: { path: { holdCastingId } },
    body,
  });
  return toJsonMutationResult(result, '取消済みオファーの再送に失敗しました。');
}

export async function listAdminContractArtists(): Promise<Record<string, unknown>[]> {
  const result = await api.GET('/admin/contract-artists');
  if (!result.response.ok || !result.data) {
    return [];
  }
  const artists = (result.data as ContractArtistsResponse).artists;
  return Array.isArray(artists) ? (artists as Record<string, unknown>[]) : [];
}

export async function listApprovedArtistsForContract(
  eventId: string
): Promise<Record<string, unknown>[]> {
  const result = await api.GET('/admin/approved-artists/{eventId}', {
    params: { path: { eventId } },
  });
  if (!result.response.ok || !result.data) return [];
  const artists = (result.data as ApprovedArtistsForContractResponse).artists;
  return Array.isArray(artists) ? (artists as Record<string, unknown>[]) : [];
}

export async function listEventContractArtistStatuses(
  eventUuid: string,
  query: EventContractArtistStatusQuery = {}
): Promise<Record<string, unknown>[]> {
  const result = await api.GET('/admin/contracts/event/{eventUuid}/artist-status', {
    params: { path: { eventUuid }, query },
    parseAs: 'text',
  });
  if (!result.response.ok) {
    throw new Error(`HTTP ${result.response.status}`);
  }
  const payload = parseJsonText(result.data);
  if (payload.success === false) return [];
  const items = payload.items;
  return Array.isArray(items) ? (items as Record<string, unknown>[]) : [];
}

export async function createCastingRecommendations(
  body: CastingRecommendationsRequest
): Promise<CastingRecommendationsResponse> {
  const result = await api.POST('/admin/casting-recommendations', { body });
  if (!result.response.ok || !result.data || result.data.success === false) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '候補の算出に失敗しました。'
    );
  }
  return result.data as CastingRecommendationsResponse;
}

export async function listCastingArtistSelection(
  query: CastingArtistSelectionQuery
): Promise<CastingArtistSelectionResponse> {
  const result = await api.GET('/admin/casting-artist-selection', {
    params: { query },
  });
  if (!result.response.ok || !result.data || result.data.success === false) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        'アーティスト一覧の取得に失敗しました。'
    );
  }
  return result.data as CastingArtistSelectionResponse;
}

export async function listAllCastingArtistSelection(
  query: Omit<CastingArtistSelectionQuery, 'limit' | 'offset'>
): Promise<Record<string, unknown>[]> {
  const artists: Record<string, unknown>[] = [];
  let offset = 0;
  for (let page = 0; page < 5; page += 1) {
    // Initial/reference batch only. Name search uses listCastingArtistSelection(q) with explicit paging.
    // eslint-disable-next-line no-await-in-loop
    const payload = await listCastingArtistSelection({ ...query, limit: 100, offset });
    artists.push(...(Array.isArray(payload.artists) ? payload.artists : []));
    if (!payload.paging?.hasMore) break;
    offset += 100;
  }
  return artists;
}

export async function getCastingArtistSelectionPreview(
  artistId: string,
  mode: 'offer' | 'contract'
): Promise<CastingArtistPreviewResponse> {
  const result = await api.GET('/admin/casting-artist-selection/{artistId}/preview', {
    params: { path: { artistId }, query: { mode } },
  });
  if (!result.response.ok || !result.data || result.data.success === false) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        'プロフィールの取得に失敗しました。'
    );
  }
  return result.data as CastingArtistPreviewResponse;
}

export async function listCastingPastEvents(
  query: CastingPastEventsQuery
): Promise<CastingPastEventsResponse> {
  const result = await api.GET('/admin/casting-past-events', {
    params: { query },
  });
  if (!result.response.ok || !result.data || result.data.success === false) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '過去公演一覧の取得に失敗しました。'
    );
  }
  return result.data as CastingPastEventsResponse;
}

export async function listCancelCompensationTargets(
  eventUuid: string
): Promise<Record<string, unknown>[]> {
  const result = await api.GET('/admin/events/{eventUuid}/cancel-compensation/targets', {
    params: { path: { eventUuid } },
    parseAs: 'text',
  });
  if (!result.response.ok) {
    const payload = parseJsonText(result.data);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '中止保証金額候補の取得に失敗しました。'
    );
  }
  const payload = parseJsonText(result.data);
  if (payload.success === false) {
    throw new Error(
      typeof payload.message === 'string'
        ? payload.message
        : '中止保証金額候補の取得に失敗しました。'
    );
  }
  const artists = payload.artists;
  return Array.isArray(artists) ? (artists as Record<string, unknown>[]) : [];
}

export async function listCommonContractAffectedArtists(
  contractArtistId: string
): Promise<Record<string, unknown>[]> {
  const result = await api.GET('/admin/contract/common-affected-artists/{contractArtistId}', {
    params: { path: { contractArtistId } },
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '一覧の取得に失敗しました。'
    );
  }
  const artists = (result.data as CommonContractAffectedArtistsResponse).artists;
  return Array.isArray(artists) ? (artists as Record<string, unknown>[]) : [];
}

export async function updateCommonContractTerms(
  body: ContractUpdateCommonRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/contract/update-common', {
    body,
    parseAs: 'text',
  });
  return toJsonMutationResult(result, '更新に失敗しました。');
}

export async function updatePersonalContractTerms(
  body: ContractUpdatePersonalRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/contract/update-personal', {
    body,
    parseAs: 'text',
  });
  return toJsonMutationResult(result, '送信に失敗しました。');
}

export async function resendDisagreedContractUnchanged(
  contractArtistId: string,
  body: ContractResendUnchangedRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST(
    '/admin/contract-artists/{contractArtistId}/resend-unchanged',
    {
      params: { path: { contractArtistId } },
      body,
      parseAs: 'text',
    }
  );
  return toJsonMutationResult(result, '本契約の再送に失敗しました。');
}

export async function reviewAdminContractInvoiceRegistration(
  contractArtistId: string,
  body: AdminContractInvoiceRegistrationReviewRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST(
    '/admin/contracts/{contractArtistId}/invoice-registration-review',
    {
      params: { path: { contractArtistId } },
      body,
      parseAs: 'text',
    }
  );
  return toJsonMutationResult(result, 'インボイス登録の確認に失敗しました。');
}

export async function getLatestHoldCastingByEvents(
  body: LatestHoldCastingByEventsRequest
): Promise<Record<string, unknown>[]> {
  const result = await api.POST('/admin/hold-casting/latest-by-events', {
    body,
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '仮押さえ情報の取得に失敗しました'
    );
  }
  const items = (result.data as LatestHoldCastingByEventsResponse).items;
  return Array.isArray(items) ? (items as Record<string, unknown>[]) : [];
}

export async function submitAdminHoldCastingOffer(
  body: CreateHoldCastingRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/casting/hold-casting', { body });
  return toJsonMutationResult(result, '送信に失敗しました。');
}

export async function listAdminHoldCastingDrafts(
  query: HoldCastingDraftListQuery = {}
): Promise<HoldCastingDraftListResponse> {
  const result = await api.GET('/admin/hold-casting-drafts', {
    params: { query },
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '下書きの取得に失敗しました'
    );
  }
  return result.data as HoldCastingDraftListResponse;
}

export async function listAdminContractDrafts(
  query: ContractDraftListQuery = {}
): Promise<ContractDraftListResponse> {
  const result = await api.GET('/admin/contract-drafts', {
    params: { query },
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        '下書きの取得に失敗しました'
    );
  }
  return result.data as ContractDraftListResponse;
}

export async function saveAdminContractDraft(
  body: SaveContractDraftRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/contract-drafts', { body });
  return toJsonMutationResult(result, '下書き保存に失敗しました。');
}

export async function submitAdminContract(
  body: SubmitContractRequest,
  options: { idempotencyKey?: string } = {}
): Promise<{ status: number; data: SubmitContractResponse & Record<string, unknown> }> {
  const result = await api.POST('/admin/submit-contract', {
    body,
    ...(options.idempotencyKey ? { headers: { 'Idempotency-Key': options.idempotencyKey } } : {}),
  });
  const data =
    result.data && typeof result.data === 'object'
      ? (result.data as SubmitContractResponse & Record<string, unknown>)
      : ((await readJsonObject(result.response)) as SubmitContractResponse & Record<string, unknown>);
  if (!result.response.ok || data.success === false) {
    const error = new Error(
      (typeof data.message === 'string' && data.message) ||
        getApiErrorMessage(result.error) ||
        '送信に失敗しました。'
    ) as Error & { status?: number; data?: Record<string, unknown> };
    error.status = result.response.status;
    error.data = data;
    throw error;
  }
  return { status: result.response.status, data };
}

export async function deleteAdminContractDraft(
  draftId: string
): Promise<Record<string, unknown>> {
  const result = await api.DELETE('/admin/contract-drafts/{draftId}', {
    params: { path: { draftId } },
  });
  return toJsonMutationResult(result, '下書きの削除に失敗しました');
}

export async function listAdminRecentContracts(
  query: RecentContractsQuery
): Promise<Record<string, unknown>> {
  const result = await api.GET('/admin/contracts/recent', {
    params: { query },
    parseAs: 'text',
  });
  const payload = parseJsonText(result.data);
  if (!result.response.ok) {
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        `HTTP ${result.response.status}`
    );
  }
  return payload;
}

export async function getAdminContractPrefill(
  contractId: string
): Promise<Record<string, unknown>> {
  const result = await api.GET('/admin/contracts/{contractId}/prefill', {
    params: { path: { contractId } },
  });
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        `HTTP ${result.response.status}`
    );
  }
  return result.data as ContractPrefillResponse;
}

export async function getAdminContractClausePolicy(): Promise<Record<string, unknown>> {
  // openapi-fetch の全パス推論がTypeScriptの再帰上限へ達するため、
  // 同じ共通fetch基盤を生成済みレスポンス型付きで呼び出す。
  const result = await requestApiJson<AdminContractClausePolicyResponse>(
    '/admin/contract-clause-policy'
  );
  if (!result.response.ok || !result.data) {
    const payload = await readJsonObject(result.response);
    throw new Error(
      (typeof payload.message === 'string' && payload.message) ||
        getApiErrorMessage(result.error) ||
        `HTTP ${result.response.status}`
    );
  }
  return result.data as Record<string, unknown>;
}

export async function saveAdminHoldCastingDraft(
  body: SaveHoldCastingDraftRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/hold-casting-drafts', { body });
  return toJsonMutationResult(result, '下書き保存に失敗しました。');
}

export async function deleteAdminHoldCastingDraft(
  draftId: string
): Promise<Record<string, unknown>> {
  const result = await api.DELETE('/admin/hold-casting-drafts/{draftId}', {
    params: { path: { draftId } },
  });
  return toJsonMutationResult(result, '下書きの削除に失敗しました');
}

export async function listContractChangeLogs(
  contractArtistId: string
): Promise<Record<string, unknown>[]> {
  const { response } = await api.GET('/common/contract-change-logs/{contractArtistId}', {
    params: { path: { contractArtistId } },
  });
  if (!response.ok) return [];
  const data = await readJsonObject(response);
  return Array.isArray(data.data) ? (data.data as Record<string, unknown>[]) : [];
}

export async function bulkSetCancelCompensation(
  eventUuid: string,
  body: BulkCancelCompensationRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/events/{eventUuid}/cancel-compensation/bulk', {
    params: { path: { eventUuid } },
    body,
  });
  return toJsonMutationResult(result, '中止保証金額の更新に失敗しました。');
}

export async function issueNoResponseContractInvoice(
  contractArtistId: string
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/contracts/{contractArtistId}/no-response-invoice', {
    params: { path: { contractArtistId } },
  });
  return toJsonMutationResult(result, '請求書発行に失敗しました。');
}

export async function requestContractInvoiceResubmission(
  contractArtistId: string
): Promise<Record<string, unknown>> {
  const result = await api.POST(
    '/admin/contracts/{contractArtistId}/request-invoice-resubmission',
    {
      params: { path: { contractArtistId } },
    }
  );
  return toJsonMutationResult(result, '請求書の再発行依頼に失敗しました。');
}

export async function createAdminSupplementalInvoice(
  contractArtistId: string,
  body: SupplementalInvoiceMutationRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/contracts/{contractArtistId}/supplemental-invoices', {
    params: { path: { contractArtistId } },
    body,
  });
  return toJsonMutationResult(result, '追補請求の作成に失敗しました。');
}

export async function updateAdminSupplementalInvoice(
  supplementalInvoiceId: string,
  body: SupplementalInvoiceMutationRequest
): Promise<Record<string, unknown>> {
  const result = await api.PATCH('/admin/supplemental-invoices/{supplementalInvoiceId}', {
    params: { path: { supplementalInvoiceId } },
    body,
  });
  return toJsonMutationResult(result, '追補請求の更新に失敗しました。');
}

export async function cancelAdminSupplementalInvoice(
  supplementalInvoiceId: string
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/supplemental-invoices/{supplementalInvoiceId}/cancel', {
    params: { path: { supplementalInvoiceId } },
  });
  return toJsonMutationResult(result, '追補請求の取り消しに失敗しました。');
}

export async function cancelAdminContract(
  body: CancelContractRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/cancel-contract', { body });
  return toJsonMutationResult(result, '取り消しに失敗しました');
}

export async function cancelAdminHoldCasting(
  body: CancelHoldCastingRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/cancel-hold-casting', { body });
  return toJsonMutationResult(result, 'キャンセルに失敗しました');
}

export async function markAdminHoldCastingContractSent(
  body: MarkHoldCastingContractSentRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/hold-casting/mark-contract-sent', { body });
  return toJsonMutationResult(result, '変更に失敗しました');
}

export async function declineAdminHoldCasting(
  body: HoldCastingDeclineRequest
): Promise<Record<string, unknown>> {
  const result = await api.POST('/admin/hold-casting/decline', { body });
  return toJsonMutationResult(result, '不参加通知の送信に失敗しました');
}

export async function respondArtistOffer(
  body: ArtistOfferResponseRequest
): Promise<ApiResult<Record<string, unknown>>> {
  const result = await api.POST('/artist/respond-offer', {
    body,
  });
  return toApiResult<Record<string, unknown>>(
    result as {
      data?: Record<string, unknown>;
      error?: unknown;
      response: Response;
    }
  );
}

export async function respondArtistContract(
  body: ArtistContractResponseRequest
): Promise<ApiResult<Record<string, unknown>>> {
  const result = await api.POST('/artist/respond-contract', {
    body,
  });
  return toApiResult<Record<string, unknown>>(
    result as {
      data?: Record<string, unknown>;
      error?: unknown;
      response: Response;
    }
  );
}

export async function listAdminEventAdditionalRewardTargets(
  eventUuid: string,
  offset = 0,
  limit = 200
) {
  const result = await api.GET(
    '/admin/contracts/events/{eventUuid}/additional-reward-targets',
    { params: { path: { eventUuid }, query: { offset, limit } } }
  );
  return toApiResult(result);
}

export async function createAdminAdditionalRewardOffers(
  eventUuid: string,
  body: AdminAdditionalRewardOfferBulkRequest
) {
  const result = await api.POST(
    '/admin/contracts/events/{eventUuid}/additional-reward-offers',
    { params: { path: { eventUuid } }, body }
  );
  return toApiResult(result);
}

export async function listAdminEventContractScheduleTargets(
  eventUuid: string,
  offset = 0,
  limit = 500
) {
  const result = await api.GET(
    '/admin/contracts/events/{eventUuid}/schedule-targets',
    { params: { path: { eventUuid }, query: { offset, limit } } }
  );
  return toApiResult(result);
}

export async function applyAdminEventContractScheduleBatch(
  eventUuid: string,
  body: EventContractScheduleBatchRequest
) {
  const result = await api.POST(
    '/admin/contracts/events/{eventUuid}/schedule-batch',
    { params: { path: { eventUuid } }, body }
  );
  return toApiResult(result);
}

export async function createAdminContractAdditionalPayment(
  contractArtistId: string,
  body: {
    event_uuid?: string | null;
    items: Array<{
      item_label: string;
      description?: string | null;
      amount: number;
      withholding_mode: 'inherit' | 'apply' | 'skip';
      tax_mode: 'taxable_included' | 'non_taxable';
      include_on_compensation: boolean;
    }>;
  }
) {
  const result = await api.POST(
    '/admin/contracts/{contractArtistId}/additional-reward-offers',
    { params: { path: { contractArtistId } }, body }
  );
  return toApiResult(result);
}

export async function cancelAdminAdditionalPayment(
  requestId: string,
  body: { version: number; content_hash: string; reason?: string | null }
) {
  const result = await api.POST(
    '/admin/contracts/additional-reward-requests/{requestId}/cancel',
    { params: { path: { requestId } }, body }
  );
  return toApiResult(result);
}

export async function listAdminContractAdditionalRewardRequests(
  contractArtistId: string
) {
  const result = await api.GET(
    '/admin/contracts/{contractArtistId}/additional-reward-requests',
    { params: { path: { contractArtistId } } }
  );
  return toApiResult(result);
}

export async function decideAdminAdditionalRewardClaimItem(
  itemId: string,
  body: AdminAdditionalRewardItemDecisionRequest
) {
  const result = await api.POST(
    '/admin/contracts/additional-reward-items/{itemId}/decision',
    { params: { path: { itemId } }, body }
  );
  return toApiResult(result);
}

export async function getAdminAdditionalRewardReceipt(itemId: string): Promise<ApiBlobResult> {
  const result = await api.GET('/admin/contracts/additional-reward-items/{itemId}/receipt', {
    params: { path: { itemId } },
    parseAs: 'blob',
  });
  return toBlobResult(result, '領収書の取得に失敗しました。');
}

export async function listArtistContractAdditionalRewardRequests(
  contractArtistId: string
) {
  const result = await api.GET(
    '/artist/contracts/{contractArtistId}/additional-reward-requests',
    { params: { path: { contractArtistId } } }
  );
  return toApiResult(result);
}

export async function createArtistAdditionalRewardClaim(
  contractArtistId: string,
  body: ArtistAdditionalRewardClaimRequest
) {
  const result = await api.POST(
    '/artist/contracts/{contractArtistId}/additional-reward-claims',
    { params: { path: { contractArtistId } }, body }
  );
  return toApiResult(result);
}

export async function respondArtistAdditionalRewardOffer(
  requestId: string,
  body: ArtistAdditionalRewardOfferResponseRequest
) {
  const result = await api.POST(
    '/artist/additional-reward-requests/{requestId}/respond',
    { params: { path: { requestId } }, body }
  );
  return toApiResult(result);
}

export async function submitArtistAdditionalRewardClaim(requestId: string) {
  const result = await api.POST(
    '/artist/additional-reward-requests/{requestId}/submit',
    { params: { path: { requestId } } }
  );
  return toApiResult(result);
}

export async function cancelArtistAdditionalRewardClaimDraft(requestId: string) {
  const result = await api.POST(
    '/artist/additional-reward-requests/{requestId}/cancel',
    { params: { path: { requestId } } }
  );
  return toApiResult(result);
}

export async function uploadArtistAdditionalRewardReceipt(itemId: string, file: File) {
  const body = new FormData();
  body.append('receipt', file);
  const result = await api.POST('/artist/additional-reward-items/{itemId}/receipt', {
    params: { path: { itemId } },
    body: body as never,
  });
  return toApiResult(result);
}

export async function confirmArtistContractInvoice(
  contractArtistId: string,
  body?: FormData | Record<string, unknown>
): Promise<ApiResult<ArtistContractInvoiceConfirmResponse>> {
  const result = await api.POST('/artist/contracts/{contractArtistId}/confirm-invoice', {
    params: { path: { contractArtistId } },
    ...(body ? { body: body as never } : {}),
  });
  return toApiResult(result);
}

export async function confirmArtistSupplementalInvoice(
  supplementalInvoiceId: number | string,
  body: { expected_revision: number }
): Promise<ApiResult<ArtistSupplementalInvoiceConfirmResponse>> {
  const result = await api.POST(
    '/artist/supplemental-invoices/{supplementalInvoiceId}/confirm-invoice',
    {
      params: { path: { supplementalInvoiceId: String(supplementalInvoiceId) } },
      body,
    }
  );
  return toApiResult(result);
}

export async function getArtistContractInvoiceFile(
  contractArtistId: string,
  options?: { download?: boolean }
): Promise<ApiBlobResult> {
  const result = await api.GET('/contracts/{contractArtistId}/invoice/file', {
    params: {
      path: { contractArtistId },
      ...(options?.download ? { query: { download: '1' as const } } : {}),
    },
    parseAs: 'blob',
  });
  return toBlobResult(result, '請求書の取得に失敗しました。');
}

export async function getArtistSupplementalInvoiceFile(
  supplementalInvoiceId: number | string
): Promise<ApiBlobResult> {
  const result = await api.GET(
    '/artist/supplemental-invoices/{supplementalInvoiceId}/invoice/file',
    {
      params: { path: { supplementalInvoiceId: String(supplementalInvoiceId) } },
      parseAs: 'blob',
    }
  );
  return toBlobResult(result, '追補請求書の取得に失敗しました。');
}
